export default __webpack_public_path__ + "static/media/4.a361d3e7.webp";